<div class="max-h-[65vh] overflow-y-auto rounded-lg border border-gray-200 bg-gray-50 p-4">
  @if (policy(); as doc) {
    <app-policy-view [document]="doc"/>
  } @else {
    <div class="flex justify-center py-4">
      <nz-spin nzSimple></nz-spin>
    </div>
  }
</div>
